var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10Cdnew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 298,
    height: 189,
    viewBox: "0 0 298 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6680b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b2334",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20830",
    "data-name": "Group 20830",
    transform: "translate(-31 -534)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19367",
    "data-name": "Rectangle 19367",
    width: 298,
    height: 189,
    transform: "translate(31 534)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38664",
    "data-name": "Path 38664",
    d: "M442.75,650.232a.921.921,0,0,1,.584-.453,9.07,9.07,0,0,0,2.546-1.12,6.886,6.886,0,0,0,2.59-3.317c.137-.37.252-.749.381-1.122a.681.681,0,0,1,.65-.541.692.692,0,0,1,.666.548,11.131,11.131,0,0,0,.864,2.156,6.929,6.929,0,0,0,3.916,3.153c.287.1.577.188.862.289a.66.66,0,0,1,.479.629.639.639,0,0,1-.453.627c-.3.112-.6.2-.9.307a6.869,6.869,0,0,0-4.475,4.434c-.108.306-.2.616-.311.922a.659.659,0,0,1-1.273,0,12.663,12.663,0,0,0-.827-2.1,6.877,6.877,0,0,0-3.88-3.225c-.267-.092-.532-.19-.8-.266a.942.942,0,0,1-.612-.45Z",
    transform: "translate(-299.738 -101.521)",
    fill: "#eef1ff",
    opacity: 0.391
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38665",
    "data-name": "Path 38665",
    d: "M442.75,650.232a.921.921,0,0,1,.584-.453,9.07,9.07,0,0,0,2.546-1.12,6.886,6.886,0,0,0,2.59-3.317c.137-.37.252-.749.381-1.122a.681.681,0,0,1,.65-.541.692.692,0,0,1,.666.548,11.131,11.131,0,0,0,.864,2.156,6.929,6.929,0,0,0,3.916,3.153c.287.1.577.188.862.289a.66.66,0,0,1,.479.629.639.639,0,0,1-.453.627c-.3.112-.6.2-.9.307a6.869,6.869,0,0,0-4.475,4.434c-.108.306-.2.616-.311.922a.659.659,0,0,1-1.273,0,12.663,12.663,0,0,0-.827-2.1,6.877,6.877,0,0,0-3.88-3.225c-.267-.092-.532-.19-.8-.266a.942.942,0,0,1-.612-.45Z",
    transform: "translate(-346.14 -94.784)",
    fill: "#eef1ff",
    opacity: 0.286
  }), /*#__PURE__*/React.createElement("g", {
    id: "_10_cd",
    "data-name": "10% cd",
    transform: "translate(92.62 578.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38617",
    "data-name": "Path 38617",
    d: "M789.495,731.044c-.456,0-.924,0-1.386-.011-1.12-.014-2.066-.581-2.068-1.236V716.056c0-.588.837-1.14,1.865-1.2.217-.016.433-.023.641-.023h35.337a5.452,5.452,0,0,1,1.117.082c.844.178,1.464.684,1.475,1.186.016.714.016,1.455,0,2.28v11.287c0,.814-.946,1.382-2.3,1.382H790.664C790.309,731.04,789.926,731.044,789.495,731.044Z",
    transform: "translate(-671.335 -663.789)",
    fill: "#3bb44a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38618",
    "data-name": "Path 38618",
    d: "M805.793,712.669h14.951a4.722,4.722,0,0,1,.928.062,1.384,1.384,0,0,1,.755.369c.014.684.014,1.4,0,2.175v11.305c0,.139-.472.47-1.386.47H787.5c-.347,0-.721.014-1.14.014s-.912,0-1.368-.011a1.617,1.617,0,0,1-1.17-.383v-13.6a1.61,1.61,0,0,1,1.019-.369c.194-.014.388-.021.575-.021H805.8m0-1.824H785.4a6.672,6.672,0,0,0-.7.025c-1.535.109-2.711,1-2.714,2.109q-.016,6.87,0,13.745c0,1.19,1.313,2.123,2.964,2.146.456,0,.933.011,1.4.011.4,0,.8,0,1.2-.016H821.05c1.883,0,3.211-.949,3.211-2.294V715.312c.016-.768.018-1.537,0-2.308-.02-.962-.912-1.786-2.2-2.052a6.25,6.25,0,0,0-1.306-.1Z",
    transform: "translate(-668.197 -660.716)",
    fill: "#588f5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38619",
    "data-name": "Path 38619",
    d: "M857.872,726.715a7.016,7.016,0,1,1-6.841-7.032A7.016,7.016,0,0,1,857.872,726.715Z",
    transform: "translate(-715.955 -667.534)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38620",
    "data-name": "Path 38620",
    d: "M794.591,722.443a1.51,1.51,0,0,1-1.551,1.571,1.548,1.548,0,0,1-1.573-1.6,1.6,1.6,0,0,1,1.562-1.578A1.553,1.553,0,0,1,794.591,722.443Z",
    transform: "translate(-675.524 -668.429)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38621",
    "data-name": "Path 38621",
    d: "M940.44,767.386a1.634,1.634,0,0,1,1.6-1.569,1.581,1.581,0,1,1-.018,3.163A1.6,1.6,0,0,1,940.44,767.386Z",
    transform: "translate(-790.528 -703.15)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38622",
    "data-name": "Path 38622",
    d: "M863.492,733.813H861.44a2.959,2.959,0,0,1-.472-.037.734.734,0,0,1-.639-.72.753.753,0,0,1,.554-.794,1.419,1.419,0,0,1,.438-.046h2.1a1.056,1.056,0,0,0-.955-.768h-1.254c-.565-.014-.892-.317-.887-.807a.772.772,0,0,1,.876-.784q2.326-.014,4.649,0a.8.8,0,0,1,.88.784.823.823,0,0,1-.894.809h-.228c-.55,0-.545,0-.42.52.043.18.107.281.315.255a2.544,2.544,0,0,1,.474,0,.791.791,0,0,1,.764.764.707.707,0,0,1-.707.787,1.057,1.057,0,0,0-1.126.732,2.336,2.336,0,0,1-1.523,1.158l-.228.064c-.018,0-.032.025-.066.055l1.95,1.824a.8.8,0,0,1,.3.782.787.787,0,0,1-1.341.415c-.762-.709-1.509-1.432-2.264-2.148l-1.031-.976a.847.847,0,0,1-.287-1,.828.828,0,0,1,.88-.495h1.323A1.259,1.259,0,0,0,863.492,733.813Z",
    transform: "translate(-728.682 -675.385)",
    fill: "#fdda41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38623",
    "data-name": "Path 38623",
    d: "M789.495,721.146c-.456,0-.924,0-1.386-.014-1.12-.014-2.066-.579-2.068-1.236V706.155c0-.588.837-1.129,1.865-1.2.217-.016.433-.023.641-.023h35.337a5.456,5.456,0,0,1,1.117.08c.844.178,1.464.684,1.475,1.188.016.711.016,1.455,0,2.266v11.287c0,.814-.946,1.382-2.3,1.382H790.664C790.309,721.134,789.926,721.146,789.495,721.146Z",
    transform: "translate(-671.335 -656.145)",
    fill: "#3bb44a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38624",
    "data-name": "Path 38624",
    d: "M805.734,702.779h15.011a4.906,4.906,0,0,1,.928.059,1.384,1.384,0,0,1,.755.369c.014.684.014,1.4,0,2.175v11.305c0,.141-.472.47-1.386.47H787.5c-.347,0-.721.016-1.14.016s-.912,0-1.368-.014a1.617,1.617,0,0,1-1.17-.383v-13.6a1.61,1.61,0,0,1,1.019-.369c.194-.014.388-.021.575-.021h20.324m0-1.824H785.4a6.672,6.672,0,0,0-.7.025c-1.535.109-2.711,1-2.714,2.109q-.016,6.875,0,13.745c0,1.19,1.313,2.125,2.964,2.146.456,0,.933.014,1.4.014.4,0,.8,0,1.2-.016H821.05c1.883,0,3.211-.946,3.211-2.294V705.422c.016-.771.018-1.539,0-2.308-.02-.965-.912-1.788-2.2-2.052a6.254,6.254,0,0,0-1.306-.1Z",
    transform: "translate(-668.197 -653.081)",
    fill: "#588f5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38625",
    "data-name": "Path 38625",
    d: "M857.872,716.815a7.016,7.016,0,1,1-6.841-7.032A7.016,7.016,0,0,1,857.872,716.815Z",
    transform: "translate(-715.955 -659.891)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38626",
    "data-name": "Path 38626",
    d: "M794.591,712.565a1.51,1.51,0,0,1-1.551,1.571,1.546,1.546,0,0,1-1.573-1.6,1.6,1.6,0,0,1,1.562-1.58A1.549,1.549,0,0,1,794.591,712.565Z",
    transform: "translate(-675.524 -660.802)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38627",
    "data-name": "Path 38627",
    d: "M940.44,757.494a1.632,1.632,0,0,1,1.6-1.567,1.581,1.581,0,1,1-.018,3.163A1.6,1.6,0,0,1,940.44,757.494Z",
    transform: "translate(-790.528 -695.515)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38628",
    "data-name": "Path 38628",
    d: "M863.492,723.937H861.44a2.967,2.967,0,0,1-.472-.034.737.737,0,0,1-.638-.723.748.748,0,0,1,.554-.791,1.353,1.353,0,0,1,.438-.046h2.1a1.056,1.056,0,0,0-.955-.771h-1.254c-.566-.014-.892-.317-.887-.807a.769.769,0,0,1,.876-.782c1.551-.011,3.1,0,4.649,0a.8.8,0,0,1,.88.787.819.819,0,0,1-.894.807h-.228c-.55,0-.545,0-.42.522.043.178.107.278.315.253a2.356,2.356,0,0,1,.474,0,.789.789,0,0,1,.764.762.709.709,0,0,1-.707.789,1.058,1.058,0,0,0-1.127.73,2.328,2.328,0,0,1-1.523,1.158l-.228.064c-.018,0-.032.027-.066.055l1.95,1.824a.807.807,0,0,1,.3.784.787.787,0,0,1-1.341.413c-.762-.709-1.509-1.432-2.264-2.148l-1.031-.978a.846.846,0,0,1-.287-1,.824.824,0,0,1,.88-.492h1.323A1.256,1.256,0,0,0,863.492,723.937Z",
    transform: "translate(-728.682 -667.763)",
    fill: "#fdda41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38629",
    "data-name": "Path 38629",
    d: "M789.495,710.146c-.456,0-.924,0-1.386-.014-1.12-.014-2.066-.579-2.068-1.236V695.155c0-.588.837-1.129,1.865-1.2.217-.016.433-.023.641-.023h35.337a5.451,5.451,0,0,1,1.117.08c.844.178,1.464.684,1.475,1.188.016.711.016,1.455,0,2.267v11.287c0,.814-.946,1.382-2.3,1.382H790.664C790.309,710.134,789.926,710.146,789.495,710.146Z",
    transform: "translate(-671.335 -647.654)",
    fill: "#3bb44a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38630",
    "data-name": "Path 38630",
    d: "M805.734,691.779h15.011a4.911,4.911,0,0,1,.928.059,1.384,1.384,0,0,1,.755.369c.014.684.014,1.4,0,2.175v11.305c0,.141-.472.47-1.386.47H787.5c-.347,0-.721.016-1.14.016s-.912,0-1.368-.014a1.618,1.618,0,0,1-1.17-.383v-13.6a1.61,1.61,0,0,1,1.019-.369c.194-.014.388-.021.575-.021h20.324m0-1.824H785.4a6.624,6.624,0,0,0-.7.025c-1.535.109-2.711,1-2.714,2.109q-.016,6.875,0,13.745c0,1.19,1.313,2.125,2.964,2.146.456,0,.933.014,1.4.014.4,0,.8,0,1.2-.016H821.05c1.883,0,3.211-.946,3.211-2.294V694.422c.016-.771.018-1.539,0-2.308-.02-.964-.912-1.788-2.2-2.052a6.25,6.25,0,0,0-1.306-.1Z",
    transform: "translate(-668.197 -644.59)",
    fill: "#588f5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38631",
    "data-name": "Path 38631",
    d: "M857.872,705.815a7.016,7.016,0,1,1-6.841-7.032A7.016,7.016,0,0,1,857.872,705.815Z",
    transform: "translate(-715.955 -651.399)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38632",
    "data-name": "Path 38632",
    d: "M794.591,701.565a1.51,1.51,0,0,1-1.551,1.571,1.546,1.546,0,0,1-1.573-1.6,1.6,1.6,0,0,1,1.562-1.58A1.549,1.549,0,0,1,794.591,701.565Z",
    transform: "translate(-675.524 -652.31)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38633",
    "data-name": "Path 38633",
    d: "M940.44,746.494a1.632,1.632,0,0,1,1.6-1.567,1.581,1.581,0,1,1-.018,3.163A1.6,1.6,0,0,1,940.44,746.494Z",
    transform: "translate(-790.528 -687.023)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38634",
    "data-name": "Path 38634",
    d: "M863.492,712.937H861.44a2.96,2.96,0,0,1-.472-.034.736.736,0,0,1-.638-.723.748.748,0,0,1,.554-.791,1.348,1.348,0,0,1,.438-.046h2.1a1.056,1.056,0,0,0-.955-.771h-1.254c-.566-.014-.892-.317-.887-.807a.769.769,0,0,1,.876-.782c1.551-.011,3.1,0,4.649,0a.8.8,0,0,1,.88.787.819.819,0,0,1-.894.807h-.228c-.55,0-.545,0-.42.522.043.178.107.278.315.253a2.36,2.36,0,0,1,.474,0,.789.789,0,0,1,.764.762.709.709,0,0,1-.707.789,1.058,1.058,0,0,0-1.127.73,2.329,2.329,0,0,1-1.523,1.158l-.228.064c-.018,0-.032.027-.066.055l1.95,1.824a.807.807,0,0,1,.3.784.787.787,0,0,1-1.341.413c-.762-.709-1.509-1.432-2.264-2.148l-1.031-.978a.846.846,0,0,1-.287-1,.824.824,0,0,1,.88-.492h1.323A1.257,1.257,0,0,0,863.492,712.937Z",
    transform: "translate(-728.682 -659.272)",
    fill: "#fdda41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38635",
    "data-name": "Path 38635",
    d: "M789.495,698.146c-.456,0-.924,0-1.386-.014-1.12-.014-2.066-.579-2.068-1.236V683.155c0-.588.837-1.129,1.865-1.2.217-.016.433-.023.641-.023h35.337a5.456,5.456,0,0,1,1.117.08c.844.178,1.464.684,1.475,1.188.016.711.016,1.455,0,2.267v11.287c0,.814-.946,1.382-2.3,1.382H790.664C790.309,698.134,789.926,698.146,789.495,698.146Z",
    transform: "translate(-671.335 -638.39)",
    fill: "#3bb44a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38636",
    "data-name": "Path 38636",
    d: "M805.734,679.779h15.011a4.906,4.906,0,0,1,.928.059,1.383,1.383,0,0,1,.755.369c.014.684.014,1.4,0,2.175v11.305c0,.141-.472.47-1.386.47H787.5c-.347,0-.721.016-1.14.016s-.912,0-1.368-.014a1.617,1.617,0,0,1-1.17-.383v-13.6a1.61,1.61,0,0,1,1.019-.369c.194-.014.388-.021.575-.021h20.324m0-1.824H785.4a6.672,6.672,0,0,0-.7.025c-1.535.109-2.711,1-2.714,2.109q-.016,6.875,0,13.745c0,1.19,1.313,2.125,2.964,2.146.456,0,.933.014,1.4.014.4,0,.8,0,1.2-.016H821.05c1.883,0,3.211-.946,3.211-2.294V682.422c.016-.771.018-1.539,0-2.308-.02-.965-.912-1.788-2.2-2.052a6.25,6.25,0,0,0-1.306-.1Z",
    transform: "translate(-668.197 -635.326)",
    fill: "#588f5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38637",
    "data-name": "Path 38637",
    d: "M857.872,693.815a7.016,7.016,0,1,1-6.841-7.032A7.017,7.017,0,0,1,857.872,693.815Z",
    transform: "translate(-715.955 -642.136)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38638",
    "data-name": "Path 38638",
    d: "M794.591,689.565a1.51,1.51,0,0,1-1.551,1.571,1.546,1.546,0,0,1-1.573-1.6,1.6,1.6,0,0,1,1.562-1.58A1.549,1.549,0,0,1,794.591,689.565Z",
    transform: "translate(-675.524 -643.047)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38639",
    "data-name": "Path 38639",
    d: "M940.44,734.494a1.632,1.632,0,0,1,1.6-1.567,1.581,1.581,0,1,1-.018,3.163A1.6,1.6,0,0,1,940.44,734.494Z",
    transform: "translate(-790.528 -677.759)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38640",
    "data-name": "Path 38640",
    d: "M863.492,700.937H861.44a2.967,2.967,0,0,1-.472-.034.737.737,0,0,1-.638-.723.748.748,0,0,1,.554-.791,1.35,1.35,0,0,1,.438-.046h2.1a1.056,1.056,0,0,0-.955-.771h-1.254c-.566-.014-.892-.317-.887-.807a.769.769,0,0,1,.876-.782c1.551-.011,3.1,0,4.649,0a.8.8,0,0,1,.88.787.819.819,0,0,1-.894.807h-.228c-.55,0-.545,0-.42.522.043.178.107.278.315.253a2.369,2.369,0,0,1,.474,0,.789.789,0,0,1,.764.762.709.709,0,0,1-.707.789,1.058,1.058,0,0,0-1.127.73,2.329,2.329,0,0,1-1.523,1.158l-.228.064c-.018,0-.032.027-.066.055l1.95,1.824a.807.807,0,0,1,.3.784.787.787,0,0,1-1.341.413c-.762-.709-1.509-1.432-2.264-2.148l-1.031-.978a.846.846,0,0,1-.287-1,.824.824,0,0,1,.88-.493h1.323A1.256,1.256,0,0,0,863.492,700.937Z",
    transform: "translate(-728.682 -650.008)",
    fill: "#fdda41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38641",
    "data-name": "Path 38641",
    d: "M422.733,2.26V6.668l-4.663.064Z",
    transform: "translate(-322.74 -1.752)",
    fill: "#37486b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38642",
    "data-name": "Path 38642",
    d: "M288.163,277.16l-4.663,4.472v-4.408",
    transform: "translate(-218.855 -213.968)",
    fill: "#37486b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38643",
    "data-name": "Path 38643",
    d: "M291.644,521.995,283,528.537V518.96l8.644-6.46h8.685v62.748h-8.685Z",
    transform: "translate(-283 -507.596)",
    fill: "#37486b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38644",
    "data-name": "Path 38644",
    d: "M392.59,528.282q.082-8.681,5.381-13.362a16.744,16.744,0,0,1,11.857-4.64,17,17,0,0,1,12.056,4.647q5.048,4.69,5.215,13.383v27.668q-.169,8.647-5.215,13.339a17.324,17.324,0,0,1-12.056,4.732,17.108,17.108,0,0,1-11.857-4.725q-5.3-4.684-5.381-13.319Zm25.817.559q-.253-9.44-8.587-9.616-8.38.173-8.546,9.616v26.647q.169,9.529,8.546,9.616,8.337-.084,8.587-9.616Z",
    transform: "translate(-367.601 -505.882)",
    fill: "#37486b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38645",
    "data-name": "Path 38645",
    d: "M563.67,518.964q.082-4.561,2.641-6.667a8.25,8.25,0,0,1,5.577-2.023,8.7,8.7,0,0,1,5.748,2.023q2.342,2.107,2.426,6.667v6.024a11.1,11.1,0,0,1-.6,3.876,6.1,6.1,0,0,1-1.824,2.709,8.476,8.476,0,0,1-5.748,2.109,8.043,8.043,0,0,1-5.577-2.109q-2.559-2.018-2.641-6.581Zm30.288-8.175h5.7l-29.584,62.739h-5.789Zm-25.477,13.558q0,4.348,3.382,4.348t3.382-4.348V519.61q0-4.348-3.382-4.348t-3.382,4.348Zm15.369,34.983q.087-4.561,2.641-6.665a8.257,8.257,0,0,1,5.577-2.023,8.7,8.7,0,0,1,5.748,2.023q2.342,2.112,2.428,6.67v6.022a11.09,11.09,0,0,1-.6,3.876,6.109,6.109,0,0,1-1.824,2.711,8.482,8.482,0,0,1-5.748,2.107,8.058,8.058,0,0,1-5.577-2.107q-2.556-2.023-2.641-6.583Zm4.82,5.377q0,4.348,3.377,4.348t3.377-4.348v-4.736q0-4.348-3.377-4.348t-3.377,4.348Z",
    transform: "translate(-499.67 -505.876)",
    fill: "#37486b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38646",
    "data-name": "Path 38646",
    d: "M291.644,502.675,283,509.215v-9.577l8.644-6.458h8.685v62.748h-8.685Z",
    transform: "translate(-283 -492.681)",
    fill: "#4d6495"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38647",
    "data-name": "Path 38647",
    d: "M392.559,508.991q.082-8.676,5.381-13.362A16.794,16.794,0,0,1,409.789,491a17,17,0,0,1,12.056,4.647q5.048,4.691,5.215,13.38v27.659q-.169,8.649-5.215,13.339a17.306,17.306,0,0,1-12.056,4.734,17.1,17.1,0,0,1-11.857-4.727q-5.3-4.681-5.381-13.317Zm25.817.561q-.253-9.445-8.587-9.616-8.38.173-8.546,9.616V536.2q.169,9.529,8.546,9.616,8.337-.084,8.587-9.616Z",
    transform: "translate(-367.57 -490.998)",
    fill: "#4d6495"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38648",
    "data-name": "Path 38648",
    d: "M563.67,499.672q.082-4.56,2.641-6.667a8.248,8.248,0,0,1,5.577-2.011,8.7,8.7,0,0,1,5.748,2.02q2.342,2.112,2.426,6.67v6.022a11.093,11.093,0,0,1-.6,3.876,6.109,6.109,0,0,1-1.824,2.711,8.486,8.486,0,0,1-5.748,2.109,8.054,8.054,0,0,1-5.577-2.109q-2.558-2.02-2.641-6.581Zm30.288-8.172h5.7l-29.584,62.738h-5.789Zm-25.477,13.554q0,4.348,3.382,4.346t3.382-4.346v-4.736q0-4.332-3.382-4.346t-3.382,4.346Zm15.369,34.981q.087-4.56,2.641-6.665a8.255,8.255,0,0,1,5.577-2.016,8.7,8.7,0,0,1,5.748,2.023q2.342,2.107,2.428,6.667v6.024a11.1,11.1,0,0,1-.6,3.876,6.12,6.12,0,0,1-1.824,2.711,8.482,8.482,0,0,1-5.748,2.107,8.058,8.058,0,0,1-5.577-2.107q-2.556-2.025-2.641-6.583Zm4.82,5.384q0,4.349,3.377,4.349t3.377-4.349v-4.736q0-4.351-3.377-4.348t-3.377,4.348Z",
    transform: "translate(-499.67 -490.992)",
    fill: "#4d6495"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38649",
    "data-name": "Path 38649",
    d: "M797.3,526.766a13.072,13.072,0,0,1-4.2,7.377,11.732,11.732,0,0,1-7.548,2.554,12.029,12.029,0,0,1-10.478-6.2q-.369-.782-.666-1.491a9.815,9.815,0,0,1-.456-1.847,93.766,93.766,0,0,1,0-16.057,9.686,9.686,0,0,1,1.113-3.3,11.768,11.768,0,0,1,3.9-4.262,11.238,11.238,0,0,1,6.583-1.943,11.116,11.116,0,0,1,7.89,2.964,13.137,13.137,0,0,1,3.854,7.26h-5.368a7.622,7.622,0,0,0-2.251-3.559,6.492,6.492,0,0,0-4.134-1.448,6.841,6.841,0,0,0-3.078.734,6.481,6.481,0,0,0-2.114,1.781,5.8,5.8,0,0,0-1.309,2.871,42.46,42.46,0,0,0-.369,6.952,41.535,41.535,0,0,0,.369,6.907,5.846,5.846,0,0,0,1.309,2.919,5.987,5.987,0,0,0,2.116,1.733,5.805,5.805,0,0,0,3.078.782q4.276,0,6.385-4.722Z",
    transform: "translate(-661.739 -499.173)",
    fill: "#37486b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38650",
    "data-name": "Path 38650",
    d: "M905.59,502.84h11.7a11.174,11.174,0,0,1,10.186,5.824,10.629,10.629,0,0,1,1.537,4.075q.249,2.132.251,7.363a51.84,51.84,0,0,1-.39,7.769,8.97,8.97,0,0,1-.55,1.988,18.648,18.648,0,0,1-.942,1.776,11.783,11.783,0,0,1-4.084,4.025,11.288,11.288,0,0,1-6.355,1.706H905.59Zm5.062,29.6h6.063q4.273,0,6.2-3.015A5.865,5.865,0,0,0,924,526.6a63.081,63.081,0,0,0,.208-6.312q0-4.508-.208-6.455a6.047,6.047,0,0,0-1.309-3.156,6.649,6.649,0,0,0-5.972-2.919h-6.063Z",
    transform: "translate(-763.625 -500.138)",
    fill: "#37486b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38651",
    "data-name": "Path 38651",
    d: "M586.474,47.224V44.8H584.1Z",
    transform: "translate(-450.911 -34.592)",
    fill: "#37486b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38652",
    "data-name": "Path 38652",
    d: "M586.1,112.784V110.36l-2.483,2.7Z",
    transform: "translate(-450.541 -85.202)",
    fill: "#37486b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38653",
    "data-name": "Path 38653",
    d: "M797.3,516.156a13.06,13.06,0,0,1-4.2,7.374,11.7,11.7,0,0,1-7.548,2.554,12.017,12.017,0,0,1-10.478-6.2q-.369-.78-.666-1.491a9.724,9.724,0,0,1-.456-1.847,93.74,93.74,0,0,1,0-16.055,9.69,9.69,0,0,1,1.113-3.29,11.761,11.761,0,0,1,3.9-4.264,12.081,12.081,0,0,1,14.479,1.033,13.123,13.123,0,0,1,3.854,7.258h-5.375a7.633,7.633,0,0,0-2.251-3.559,6.5,6.5,0,0,0-4.134-1.448,6.841,6.841,0,0,0-3.078.737,6.426,6.426,0,0,0-2.114,1.781,5.794,5.794,0,0,0-1.309,2.871,42.46,42.46,0,0,0-.369,6.952,41.491,41.491,0,0,0,.369,6.9,5.836,5.836,0,0,0,1.309,2.919,5.941,5.941,0,0,0,2.116,1.733,5.806,5.806,0,0,0,3.078.784q4.276,0,6.385-4.722Z",
    transform: "translate(-661.739 -490.998)",
    fill: "#6887c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38654",
    "data-name": "Path 38654",
    d: "M905.59,492.2h11.7a11.173,11.173,0,0,1,10.186,5.826,10.617,10.617,0,0,1,1.537,4.073q.248,2.132.251,7.365a51.791,51.791,0,0,1-.39,7.767,8.953,8.953,0,0,1-.55,1.991,18.655,18.655,0,0,1-.942,1.774,11.788,11.788,0,0,1-4.084,4.027,11.337,11.337,0,0,1-6.355,1.706H905.59Zm5.062,29.6h6.063q4.273,0,6.2-3.014A5.866,5.866,0,0,0,924,515.958a63.038,63.038,0,0,0,.208-6.312q0-4.508-.208-6.453a6.046,6.046,0,0,0-1.309-3.156,6.647,6.647,0,0,0-5.972-2.921h-6.063Z",
    transform: "translate(-763.625 -491.924)",
    fill: "#6887c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1416",
    "data-name": "Ellipse 1416",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(145.023 64.85)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19368",
    "data-name": "Rectangle 19368",
    width: 10.877,
    height: 1.578,
    transform: "translate(145.023 66.491)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1417",
    "data-name": "Ellipse 1417",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(145.023 63.37)",
    fill: "#fecb33"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1418",
    "data-name": "Ellipse 1418",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(145.023 61.824)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19369",
    "data-name": "Rectangle 19369",
    width: 10.877,
    height: 1.578,
    transform: "translate(145.023 63.466)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1419",
    "data-name": "Ellipse 1419",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(145.023 60.344)",
    fill: "#fecb33"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1420",
    "data-name": "Ellipse 1420",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(145.023 58.8)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19370",
    "data-name": "Rectangle 19370",
    width: 10.877,
    height: 1.578,
    transform: "translate(145.023 60.442)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1421",
    "data-name": "Ellipse 1421",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(145.023 57.32)",
    fill: "#fecb33"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1422",
    "data-name": "Ellipse 1422",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(145.023 55.774)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19371",
    "data-name": "Rectangle 19371",
    width: 10.877,
    height: 1.578,
    transform: "translate(145.023 57.416)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1423",
    "data-name": "Ellipse 1423",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(145.023 54.294)",
    fill: "#fecb33"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1424",
    "data-name": "Ellipse 1424",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(145.023 52.815)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19372",
    "data-name": "Rectangle 19372",
    width: 10.877,
    height: 1.578,
    transform: "translate(145.023 54.454)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1425",
    "data-name": "Ellipse 1425",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(145.023 51.332)",
    fill: "#fecb33"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1426",
    "data-name": "Ellipse 1426",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(145.023 49.789)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19373",
    "data-name": "Rectangle 19373",
    width: 10.877,
    height: 1.578,
    transform: "translate(145.023 51.43)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1427",
    "data-name": "Ellipse 1427",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(145.023 48.309)",
    fill: "#fecb33"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1428",
    "data-name": "Ellipse 1428",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(155.966 64.85)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19374",
    "data-name": "Rectangle 19374",
    width: 10.877,
    height: 1.578,
    transform: "translate(155.966 66.491)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1429",
    "data-name": "Ellipse 1429",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(155.966 63.37)",
    fill: "#fecb33"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1430",
    "data-name": "Ellipse 1430",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(155.966 61.824)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19375",
    "data-name": "Rectangle 19375",
    width: 10.877,
    height: 1.578,
    transform: "translate(155.966 63.466)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1431",
    "data-name": "Ellipse 1431",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(155.966 60.344)",
    fill: "#fecb33"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1432",
    "data-name": "Ellipse 1432",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(155.966 58.8)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19376",
    "data-name": "Rectangle 19376",
    width: 10.877,
    height: 1.578,
    transform: "translate(155.966 60.442)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1433",
    "data-name": "Ellipse 1433",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(155.966 57.32)",
    fill: "#fecb33"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1434",
    "data-name": "Ellipse 1434",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(155.966 55.774)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19377",
    "data-name": "Rectangle 19377",
    width: 10.877,
    height: 1.578,
    transform: "translate(155.966 57.416)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1435",
    "data-name": "Ellipse 1435",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(155.966 54.294)",
    fill: "#fecb33"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1436",
    "data-name": "Ellipse 1436",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(155.966 52.815)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19378",
    "data-name": "Rectangle 19378",
    width: 10.877,
    height: 1.578,
    transform: "translate(155.966 54.454)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1437",
    "data-name": "Ellipse 1437",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(155.966 51.332)",
    fill: "#fecb33"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1438",
    "data-name": "Ellipse 1438",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(155.966 49.789)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19379",
    "data-name": "Rectangle 19379",
    width: 10.877,
    height: 1.578,
    transform: "translate(155.966 51.43)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1439",
    "data-name": "Ellipse 1439",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(155.966 48.309)",
    fill: "#fecb33"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1440",
    "data-name": "Ellipse 1440",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(155.966 46.763)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19380",
    "data-name": "Rectangle 19380",
    width: 10.877,
    height: 1.578,
    transform: "translate(155.966 48.405)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1441",
    "data-name": "Ellipse 1441",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(155.966 45.283)",
    fill: "#fecb33"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1442",
    "data-name": "Ellipse 1442",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(155.966 43.739)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19381",
    "data-name": "Rectangle 19381",
    width: 10.877,
    height: 1.578,
    transform: "translate(155.966 45.379)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1443",
    "data-name": "Ellipse 1443",
    cx: 5.438,
    cy: 3.122,
    rx: 5.438,
    ry: 3.122,
    transform: "translate(155.966 42.257)",
    fill: "#fecb33"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1444",
    "data-name": "Ellipse 1444",
    cx: 6.179,
    cy: 6.179,
    r: 6.179,
    transform: "translate(162.079 61.053)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1445",
    "data-name": "Ellipse 1445",
    cx: 4.633,
    cy: 4.633,
    r: 4.633,
    transform: "translate(163.625 62.599)",
    fill: "#fdd93f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38655",
    "data-name": "Path 38655",
    d: "M1017.371,775.73a.155.155,0,0,1,.066.144v.265c0,.089-.041.141-.146.141h-.7c-.007,0,0,.025.018.036a1.008,1.008,0,0,1,.155.351c0,.05.034.062.08.062h.456a.255.255,0,0,1,.084.011.117.117,0,0,1,.071.112v.31c0,.1-.041.121-.128.121h-.477c-.036,0-.052,0-.059.048a1.222,1.222,0,0,1-.317.625,1.393,1.393,0,0,1-.531.342,2,2,0,0,1-.456.112l.155.171c.456.5.887,1.026,1.32,1.55.032.039.059.08.034.132a.1.1,0,0,1-.1.068h-.643a.119.119,0,0,1-.089-.046l-.752-.887c-.249-.292-.506-.579-.766-.862-.155-.169-.135-.114-.137-.347v-.228c0-.1.043-.141.144-.141h.518a1.153,1.153,0,0,0,.618-.2.6.6,0,0,0,.208-.283c.016-.046.014-.048-.034-.048h-1.3a.187.187,0,0,1-.08,0,.091.091,0,0,1-.062-.078,2.194,2.194,0,0,1,0-.367c0-.059.039-.087.1-.1h1.3c.036,0,.046,0,.023-.041a.548.548,0,0,0-.2-.182,1.106,1.106,0,0,0-.456-.123c-.208-.018-.413,0-.62,0-.112,0-.153-.041-.153-.153v-.358a.135.135,0,0,1,.073-.139Z",
    transform: "translate(-847.705 -710.803)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1446",
    "data-name": "Ellipse 1446",
    cx: 145.5,
    cy: 1,
    rx: 145.5,
    ry: 1,
    transform: "translate(34 665)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Minimum_10_CD_on_all_medicines",
    "data-name": "Minimum 10% CD on all medicines",
    transform: "translate(59 699)",
    fill: "#364668",
    fontSize: 15,
    fontFamily: "Ubuntu-Medium, Ubuntu",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Minimum 10% CD on all medicines")), /*#__PURE__*/React.createElement("path", {
    id: "Path_38656",
    "data-name": "Path 38656",
    d: "M442.75,650.232a.921.921,0,0,1,.584-.453,9.07,9.07,0,0,0,2.546-1.12,6.886,6.886,0,0,0,2.59-3.317c.137-.37.252-.749.381-1.122a.681.681,0,0,1,.65-.541.692.692,0,0,1,.666.548,11.131,11.131,0,0,0,.864,2.156,6.929,6.929,0,0,0,3.916,3.153c.287.1.577.188.862.289a.66.66,0,0,1,.479.629.639.639,0,0,1-.453.627c-.3.112-.6.2-.9.307a6.869,6.869,0,0,0-4.475,4.434c-.108.306-.2.616-.311.922a.659.659,0,0,1-1.273,0,12.663,12.663,0,0,0-.827-2.1,6.877,6.877,0,0,0-3.88-3.225c-.267-.092-.532-.19-.8-.266a.942.942,0,0,1-.612-.45Z",
    transform: "translate(-379.357 -28.813)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38660",
    "data-name": "Path 38660",
    d: "M442.75,650.232a.921.921,0,0,1,.584-.453,9.07,9.07,0,0,0,2.546-1.12,6.886,6.886,0,0,0,2.59-3.317c.137-.37.252-.749.381-1.122a.681.681,0,0,1,.65-.541.692.692,0,0,1,.666.548,11.131,11.131,0,0,0,.864,2.156,6.929,6.929,0,0,0,3.916,3.153c.287.1.577.188.862.289a.66.66,0,0,1,.479.629.639.639,0,0,1-.453.627c-.3.112-.6.2-.9.307a6.869,6.869,0,0,0-4.475,4.434c-.108.306-.2.616-.311.922a.659.659,0,0,1-1.273,0,12.663,12.663,0,0,0-.827-2.1,6.877,6.877,0,0,0-3.88-3.225c-.267-.092-.532-.19-.8-.266a.942.942,0,0,1-.612-.45Z",
    transform: "translate(-153.996 -20.261)",
    fill: "#eef1ff",
    opacity: 0.286
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38663",
    "data-name": "Path 38663",
    d: "M442.75,650.232a.921.921,0,0,1,.584-.453,9.07,9.07,0,0,0,2.546-1.12,6.886,6.886,0,0,0,2.59-3.317c.137-.37.252-.749.381-1.122a.681.681,0,0,1,.65-.541.692.692,0,0,1,.666.548,11.131,11.131,0,0,0,.864,2.156,6.929,6.929,0,0,0,3.916,3.153c.287.1.577.188.862.289a.66.66,0,0,1,.479.629.639.639,0,0,1-.453.627c-.3.112-.6.2-.9.307a6.869,6.869,0,0,0-4.475,4.434c-.108.306-.2.616-.311.922a.659.659,0,0,1-1.273,0,12.663,12.663,0,0,0-.827-2.1,6.877,6.877,0,0,0-3.88-3.225c-.267-.092-.532-.19-.8-.266a.942.942,0,0,1-.612-.45Z",
    transform: "translate(-257.124 -92.156)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38657",
    "data-name": "Path 38657",
    d: "M640.522,499.75a.962.962,0,0,1,.446.566,6.832,6.832,0,0,0,4.155,4.154c.294.113.542.253.578.6a.632.632,0,0,1-.47.713,7.431,7.431,0,0,0-1.641.823A6.875,6.875,0,0,0,641,509.892c-.033.085-.062.173-.1.257a.658.658,0,0,1-1.227-.017,9.35,9.35,0,0,0-.453-1.047,6.842,6.842,0,0,0-3.787-3.269.717.717,0,0,1-.552-.576.654.654,0,0,1,.5-.736,7.05,7.05,0,0,0,1.878-1,6.8,6.8,0,0,0,2.34-3.148,1.023,1.023,0,0,1,.459-.605Z",
    transform: "translate(-563.359 78.938)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38662",
    "data-name": "Path 38662",
    d: "M640.522,499.75a.962.962,0,0,1,.446.566,6.832,6.832,0,0,0,4.155,4.154c.294.113.542.253.578.6a.632.632,0,0,1-.47.713,7.431,7.431,0,0,0-1.641.823A6.875,6.875,0,0,0,641,509.892c-.033.085-.062.173-.1.257a.658.658,0,0,1-1.227-.017,9.35,9.35,0,0,0-.453-1.047,6.842,6.842,0,0,0-3.787-3.269.717.717,0,0,1-.552-.576.654.654,0,0,1,.5-.736,7.05,7.05,0,0,0,1.878-1,6.8,6.8,0,0,0,2.34-3.148,1.023,1.023,0,0,1,.459-.605Z",
    transform: "translate(-351.536 68.083)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38658",
    "data-name": "Path 38658",
    d: "M446.345,499.75a.83.83,0,0,1,.453.5,3.64,3.64,0,0,0,2.16,2.189c.057.023.119.043.177.07a.635.635,0,0,1,.388.607.612.612,0,0,1-.388.583,5.74,5.74,0,0,0-.91.446,3.664,3.664,0,0,0-1.4,1.735c-.016.04-.031.079-.045.119a.66.66,0,0,1-1.274,0,3.89,3.89,0,0,0-.514-.968,3.6,3.6,0,0,0-1.683-1.263.838.838,0,0,1-.521-.46v-.424a.914.914,0,0,1,.535-.445,3.58,3.58,0,0,0,2.153-2.154.924.924,0,0,1,.445-.535Z",
    transform: "translate(-387.555 109.003)",
    fill: "#dadafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38672",
    "data-name": "Path 38672",
    d: "M446.345,499.75a.83.83,0,0,1,.453.5,3.64,3.64,0,0,0,2.16,2.189c.057.023.119.043.177.07a.635.635,0,0,1,.388.607.612.612,0,0,1-.388.583,5.74,5.74,0,0,0-.91.446,3.664,3.664,0,0,0-1.4,1.735c-.016.04-.031.079-.045.119a.66.66,0,0,1-1.274,0,3.89,3.89,0,0,0-.514-.968,3.6,3.6,0,0,0-1.683-1.263.838.838,0,0,1-.521-.46v-.424a.914.914,0,0,1,.535-.445,3.58,3.58,0,0,0,2.153-2.154.924.924,0,0,1,.445-.535Z",
    transform: "translate(-187.813 49.185)",
    fill: "#eef1ff",
    opacity: 0.286
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38670",
    "data-name": "Path 38670",
    d: "M446.345,499.75a.83.83,0,0,1,.453.5,3.64,3.64,0,0,0,2.16,2.189c.057.023.119.043.177.07a.635.635,0,0,1,.388.607.612.612,0,0,1-.388.583,5.74,5.74,0,0,0-.91.446,3.664,3.664,0,0,0-1.4,1.735c-.016.04-.031.079-.045.119a.66.66,0,0,1-1.274,0,3.89,3.89,0,0,0-.514-.968,3.6,3.6,0,0,0-1.683-1.263.838.838,0,0,1-.521-.46v-.424a.914.914,0,0,1,.535-.445,3.58,3.58,0,0,0,2.153-2.154.924.924,0,0,1,.445-.535Z",
    transform: "translate(-257.164 104.885)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38666",
    "data-name": "Path 38666",
    d: "M446.345,499.75a.83.83,0,0,1,.453.5,3.64,3.64,0,0,0,2.16,2.189c.057.023.119.043.177.07a.635.635,0,0,1,.388.607.612.612,0,0,1-.388.583,5.74,5.74,0,0,0-.91.446,3.664,3.664,0,0,0-1.4,1.735c-.016.04-.031.079-.045.119a.66.66,0,0,1-1.274,0,3.89,3.89,0,0,0-.514-.968,3.6,3.6,0,0,0-1.683-1.263.838.838,0,0,1-.521-.46v-.424a.914.914,0,0,1,.535-.445,3.58,3.58,0,0,0,2.153-2.154.924.924,0,0,1,.445-.535Z",
    transform: "translate(-315.894 65.328)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38673",
    "data-name": "Path 38673",
    d: "M446.345,499.75a.83.83,0,0,1,.453.5,3.64,3.64,0,0,0,2.16,2.189c.057.023.119.043.177.07a.635.635,0,0,1,.388.607.612.612,0,0,1-.388.583,5.74,5.74,0,0,0-.91.446,3.664,3.664,0,0,0-1.4,1.735c-.016.04-.031.079-.045.119a.66.66,0,0,1-1.274,0,3.89,3.89,0,0,0-.514-.968,3.6,3.6,0,0,0-1.683-1.263.838.838,0,0,1-.521-.46v-.424a.914.914,0,0,1,.535-.445,3.58,3.58,0,0,0,2.153-2.154.924.924,0,0,1,.445-.535Z",
    transform: "translate(-390.922 62.7)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38667",
    "data-name": "Path 38667",
    d: "M446.345,499.75a.83.83,0,0,1,.453.5,3.64,3.64,0,0,0,2.16,2.189c.057.023.119.043.177.07a.635.635,0,0,1,.388.607.612.612,0,0,1-.388.583,5.74,5.74,0,0,0-.91.446,3.664,3.664,0,0,0-1.4,1.735c-.016.04-.031.079-.045.119a.66.66,0,0,1-1.274,0,3.89,3.89,0,0,0-.514-.968,3.6,3.6,0,0,0-1.683-1.263.838.838,0,0,1-.521-.46v-.424a.914.914,0,0,1,.535-.445,3.58,3.58,0,0,0,2.153-2.154.924.924,0,0,1,.445-.535Z",
    transform: "translate(-223.621 42.408)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38668",
    "data-name": "Path 38668",
    d: "M446.345,499.75a.83.83,0,0,1,.453.5,3.64,3.64,0,0,0,2.16,2.189c.057.023.119.043.177.07a.635.635,0,0,1,.388.607.612.612,0,0,1-.388.583,5.74,5.74,0,0,0-.91.446,3.664,3.664,0,0,0-1.4,1.735c-.016.04-.031.079-.045.119a.66.66,0,0,1-1.274,0,3.89,3.89,0,0,0-.514-.968,3.6,3.6,0,0,0-1.683-1.263.838.838,0,0,1-.521-.46v-.424a.914.914,0,0,1,.535-.445,3.58,3.58,0,0,0,2.153-2.154.924.924,0,0,1,.445-.535Z",
    transform: "translate(-129.178 93.429)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38669",
    "data-name": "Path 38669",
    d: "M446.345,499.75a.83.83,0,0,1,.453.5,3.64,3.64,0,0,0,2.16,2.189c.057.023.119.043.177.07a.635.635,0,0,1,.388.607.612.612,0,0,1-.388.583,5.74,5.74,0,0,0-.91.446,3.664,3.664,0,0,0-1.4,1.735c-.016.04-.031.079-.045.119a.66.66,0,0,1-1.274,0,3.89,3.89,0,0,0-.514-.968,3.6,3.6,0,0,0-1.683-1.263.838.838,0,0,1-.521-.46v-.424a.914.914,0,0,1,.535-.445,3.58,3.58,0,0,0,2.153-2.154.924.924,0,0,1,.445-.535Z",
    transform: "translate(-170.429 137.223)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38661",
    "data-name": "Path 38661",
    d: "M446.345,499.75a.83.83,0,0,1,.453.5,3.64,3.64,0,0,0,2.16,2.189c.057.023.119.043.177.07a.635.635,0,0,1,.388.607.612.612,0,0,1-.388.583,5.74,5.74,0,0,0-.91.446,3.664,3.664,0,0,0-1.4,1.735c-.016.04-.031.079-.045.119a.66.66,0,0,1-1.274,0,3.89,3.89,0,0,0-.514-.968,3.6,3.6,0,0,0-1.683-1.263.838.838,0,0,1-.521-.46v-.424a.914.914,0,0,1,.535-.445,3.58,3.58,0,0,0,2.153-2.154.924.924,0,0,1,.445-.535Z",
    transform: "translate(-175.731 98.147)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38659",
    "data-name": "Path 38659",
    d: "M713.684,767.336a.634.634,0,0,1-.48.644,3.7,3.7,0,0,0-1.886,1.5,4.3,4.3,0,0,0-.377.779.634.634,0,0,1-.64.456.64.64,0,0,1-.618-.461,3.664,3.664,0,0,0-2.263-2.275.658.658,0,0,1,0-1.271,3.634,3.634,0,0,0,2.246-2.237.685.685,0,0,1,.636-.5.676.676,0,0,1,.655.509,3.667,3.667,0,0,0,2.249,2.236A.642.642,0,0,1,713.684,767.336Z",
    transform: "translate(-638.163 -128.323)",
    fill: "#eef1ff",
    opacity: 0.286
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38671",
    "data-name": "Path 38671",
    d: "M713.684,767.336a.634.634,0,0,1-.48.644,3.7,3.7,0,0,0-1.886,1.5,4.3,4.3,0,0,0-.377.779.634.634,0,0,1-.64.456.64.64,0,0,1-.618-.461,3.664,3.664,0,0,0-2.263-2.275.658.658,0,0,1,0-1.271,3.634,3.634,0,0,0,2.246-2.237.685.685,0,0,1,.636-.5.676.676,0,0,1,.655.509,3.667,3.667,0,0,0,2.249,2.236A.642.642,0,0,1,713.684,767.336Z",
    transform: "translate(-561.088 -121.574)",
    fill: "#dadafd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg10Cdnew);
export default __webpack_public_path__ + "static/media/10cdnew.158d6fd165c60b3549b054e025d2bdac.svg";
export { ForwardRef as ReactComponent };